import React from 'react';
import HrbTranslate from "../../language/HrbTranslate";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import './DialogBox.scss';

const DialogBox = ({ showResetDialog, handleCloseDialog, handleConfirmDialog, dialogTitle, dialogText, dialogCancelText, dialogConfirmText, isRedirectionError }) => {
    const [isHovered, setIsHovered] = React.useState(false);

    return (
        <Modal
            show={showResetDialog}
            onHide={handleCloseDialog}
            centered
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            contentClassName="border"
            className="hrb-dialog-box-modal"
            dialogClassName="hrb-dialog-box"
        >
            <Modal.Header style={{ borderBottom: 'none', padding: '24px 24px 0 24px' }}>
                <Modal.Title
                    id="alert-dialog-title"
                    style={{
                        fontWeight: 600,
                        fontSize: '24px',
                        lineHeight: '32px',
                        color: 'var(--General-Product-Colours-Black, #231F20)'
                    }}
                >
                    <HrbTranslate text={dialogTitle} />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body
                id="alert-dialog-description"
                style={{
                    padding: '16px 24px 24px 24px',
                    color: 'var(--General-Product-Colours-Black, #231F20)',
                    fontSize: '14px',
                    fontWeight: 400,
                    lineHeight: '20px',
                    letterSpacing: '0.25px'
                }}
            >
                <HrbTranslate text={dialogText} />
            </Modal.Body>
            <Modal.Footer
                style={{
                    justifyContent: isRedirectionError ? 'flex-end' : 'center',
                    borderTop: 'none',
                    padding: '0 16px 16px 16px'
                }}
            >
                {!isRedirectionError &&
                    <Button onClick={handleCloseDialog} className="hrb-dialog-box-cancel-button" variant="light">
                        <HrbTranslate text={dialogCancelText} />
                    </Button>
                }
                {isRedirectionError ? (
                    <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                        <Button
                            onClick={handleConfirmDialog}
                            variant="success"
                            style={{
                                backgroundColor: isHovered ? '#007500' : '#008F00',
                                color: '#FFF',
                                border: '1px solid #008F00',
                            }}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                        >
                            <HrbTranslate text={dialogConfirmText} />
                        </Button>
                    </div>
                ) : (
                    <Button onClick={handleConfirmDialog} autoFocus className="hrb-dialog-box-confirm-button" variant="light">
                        <HrbTranslate text={dialogConfirmText} />
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    )
}

export default DialogBox;

